import { PrimaryProductKeys } from '../../../../common/constants/primary-product-keys';
import type { PrimaryProductKey } from '../../../../common/constants/product-keys';

export const getUrsProductKey = (
	primaryProduct?: PrimaryProductKey,
): 'confluence' | 'jira' | 'loom' => {
	// URS (User Recommendation Service) rejects product keys it does not recognise, so anything
	// else falls back to 'confluence' rather than failing deserialization.
	return primaryProduct === PrimaryProductKeys.Jira ||
		primaryProduct === PrimaryProductKeys.Confluence ||
		primaryProduct === PrimaryProductKeys.Loom
		? primaryProduct
		: PrimaryProductKeys.Confluence;
};
